import { useState } from 'react';

import { ConfirmationPopup } from '@/components/Popup/ConfirmationPopup/ConfirmationPopup';
import Button from '@/components/shared/Button/Button';

import { useSyncTariffs } from '../../hooks/useSyncTariffs';

const SyncLTVButton = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const syncTariffsMutation = useSyncTariffs();

  const syncTariffs = async () => {
    syncTariffsMutation.mutate();
    setIsPopupOpen(false);
  };

  return (
    <>
      <ConfirmationPopup
        isOpen={isPopupOpen}
        title="Sync Tariffs LTV"
        description="Are you sure you want to sync Tariffs LTV?"
        handleConfirm={syncTariffs}
        closePopup={() => setIsPopupOpen(false)}
        confirmText="Sync Tariffs LTV"
      />

      <Button
        size="s"
        className="ml-auto"
        onClick={() => setIsPopupOpen(true)}
        label="Sync Tariffs LTV"
      />
    </>
  );
};

export default SyncLTVButton;
